import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * The programmatic identifier of the redirectPolicy.
 */
export var redirectPolicyName = "redirectPolicy";
/**
 * Methods that are allowed to follow redirects 301 and 302
 */

var allowedRedirect = ["GET", "HEAD"];
/**
 * A policy to follow Location headers from the server in order
 * to support server-side redirection.
 * In the browser, this policy is not used.
 * @param options - Options to control policy behavior.
 */

export function redirectPolicy() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$maxRetries = options.maxRetries,
      maxRetries = _options$maxRetries === void 0 ? 20 : _options$maxRetries;
  return {
    name: redirectPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next(request);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", handleRedirect(next, response, maxRetries));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}

function handleRedirect(_x3, _x4, _x5) {
  return _handleRedirect.apply(this, arguments);
}

function _handleRedirect() {
  _handleRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(next, response, maxRetries) {
    var currentRetries,
        request,
        status,
        headers,
        locationHeader,
        url,
        res,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            currentRetries = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 0;
            request = response.request, status = response.status, headers = response.headers;
            locationHeader = headers.get("location");

            if (!(locationHeader && (status === 300 || status === 301 && allowedRedirect.includes(request.method) || status === 302 && allowedRedirect.includes(request.method) || status === 303 && request.method === "POST" || status === 307) && currentRetries < maxRetries)) {
              _context2.next = 12;
              break;
            }

            url = new URL(locationHeader, request.url);
            request.url = url.toString(); // POST request with Status code 303 should be converted into a
            // redirected GET request if the redirect url is present in the location header

            if (status === 303) {
              request.method = "GET";
              request.headers.delete("Content-Length");
              delete request.body;
            }

            request.headers.delete("Authorization");
            _context2.next = 10;
            return next(request);

          case 10:
            res = _context2.sent;
            return _context2.abrupt("return", handleRedirect(next, res, maxRetries, currentRetries + 1));

          case 12:
            return _context2.abrupt("return", response);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _handleRedirect.apply(this, arguments);
}